// =============================================================================
// Chat — SEVRIC Chat surface mounted inside Battery Care.
//
// The actual UI lives in the shared `/chat` package — this file is just the
// per-app wrapper that bootstraps the Supabase session via the Firebase Auth
// bridge and passes the profile through.
// =============================================================================
import { useEffect, useState } from "react";
import { useAuth } from "../auth/AuthProvider.jsx";
import { ChatLayout, connectChat, disconnectChat, SevricLoader } from "../../../chat/src/index.js";
import { getFirebaseApp } from "../lib/firebase.js";
import "../../../chat/src/components/chat.css";

export default function ChatPage() {
  const { profile } = useAuth();
  const [status, setStatus] = useState("idle"); // 'idle'|'connecting'|'ready'|'error'
  const [error, setError]   = useState(null);

  useEffect(() => {
    if (!profile?.uid) return;
    let cancelled = false;
    setStatus("connecting");
    (async () => {
      try {
        await connectChat(getFirebaseApp());
        if (!cancelled) setStatus("ready");
      } catch (err) {
        if (!cancelled) { setError(err); setStatus("error"); }
      }
    })();
    return () => { cancelled = true; disconnectChat(); };
  }, [profile?.uid]);

  if (status === "connecting" || status === "idle") {
    return <SevricLoader app="chat" />;
  }
  if (status === "error") {
    return (
      <main style={{ padding: 60, maxWidth: 540, margin: "60px auto" }}>
        <div className="w-shell" style={{ padding: 24, borderColor: "rgba(124,41,53,0.30)" }}>
          <div style={{ fontSize: 11.5, letterSpacing: "0.22em", textTransform: "uppercase", color: "#7C2935", marginBottom: 8 }}>SEVRIC CHAT</div>
          <h1 style={{ fontFamily: "'Crimson Pro', serif", fontSize: 28, color: "var(--text, #14161A)", letterSpacing: "-0.02em", margin: "4px 0 12px" }}>
            Couldn't connect.
          </h1>
          <p style={{ fontSize: 14, color: "var(--text-muted, #4A4D54)", marginBottom: 14 }}>
            Your SEVRIC Chat session couldn't be established. Most often this means the chat backend isn't fully configured yet for this deployment.
          </p>
          <pre style={{ fontSize: 12, color: "var(--text-dim, #6A6D74)", background: "var(--bg, #F6F6F3)", padding: 10, borderRadius: 8, overflow: "auto" }}>{String(error?.message || error || "unknown error")}</pre>
        </div>
      </main>
    );
  }
  return <ChatLayout profile={profile} />;
}
